<div class="listado__stats">
    <div class="listado__stat">
        <div class="listado__stat-value">{{ totalTramites }}</div>
        <div class="listado__stat-label">{{ 'COMMON.TOTAL' | translate }}</div>
    </div>
    <div class="listado__stat">
        <div class="listado__stat-value is-muted">{{ tramitesMostrados }}</div>
        <div class="listado__stat-label">{{ 'COMMON.SHOWING' | translate }}</div>
    </div>
</div>

<!-- Mobile: botón disparador del sheet de filtros -->
<button type="button" class="filters-trigger" (click)="filtersOpen = !filtersOpen">
    <mat-icon>tune</mat-icon>
    {{ 'COMMON.FILTERS' | translate }}<span *ngIf="activeFilterCount > 0" class="filter-count">&nbsp;{{ activeFilterCount }}</span>
</button>

<!-- Toolbar de filtros (bottom-sheet en móvil) -->
<div class="listado__toolbar" [class.is-open]="filtersOpen">
    <div class="listado__filter listado__toolbar-fields">
        <div class="filter-sheet__grip"></div>
        <div class="filter-sheet__head">
            <span>{{ 'COMMON.FILTERS' | translate }}{{ activeFilterCount > 0 ? ' (' + activeFilterCount + ')' : '' }}</span>
            <button type="button" (click)="filtersOpen = false">×</button>
        </div>

        <input type="text" class="em-input" [formControl]="filtroDNI" [placeholder]="'TRAMITES.PH_DNI' | translate">
        <input type="text" class="em-input" [formControl]="filtroNombre" [placeholder]="'TRAMITES.PH_NOMBRE' | translate">
        <div class="em-date-range" [formGroup]="filtroFecha">
            <input type="date" class="em-input" formControlName="start" [attr.aria-label]="'COMMON.DATE_START' | translate">
            <span class="em-date-range__sep">–</span>
            <input type="date" class="em-input" formControlName="end" [attr.aria-label]="'COMMON.DATE_END' | translate">
        </div>
        <select class="em-select" [formControl]="filtroEstado">
            <option value="">{{ 'TRAMITES.ALL_STATES' | translate }}</option>
            <option *ngFor="let opcion of listadoEstados" [value]="opcion.label">{{ opcion.label }}</option>
        </select>
        <select class="em-select" [formControl]="filtroPaso">
            <option value="">{{ 'TRAMITES.ALL_STEPS' | translate }}</option>
            <option *ngFor="let opcion of listadoPasos" [value]="opcion.label">{{ opcion.label }}</option>
        </select>
        <label class="fb-toggle listado__toggle">
            <input type="checkbox" [formControl]="filtroCargaTotal" [disabled]="cargandoTramites">
            <span class="fb-toggle__track">
                <span class="fb-toggle__thumb"></span>
            </span>
            <span class="fb-toggle__text">{{ 'TRAMITES.LOAD_ALL' | translate }}</span>
        </label>

        <div class="filter-sheet__foot">
            <button type="button" class="em-btn" (click)="clearFilters()">{{ 'COMMON.CLEAR' | translate }}</button>
            <button type="button" class="em-btn em-btn--primary" (click)="filtersOpen = false">{{ 'COMMON.APPLY' | translate }}</button>
        </div>
    </div>
</div>

<!-- Listado con variante C (tarjetas con acento) -->
<div class="listado listado--cards-accent">
    <mat-table *ngIf="dataSource" #table [dataSource]="dataSource" matSort matSortActive="Fecha modificación" matSortDirection="desc" class="table align-middle mb-0 bg-white">
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
            <mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="column === 'Acciones'" sortActionDescription="Sort by {{column}}" class="header" [class.em-th-actions]="column === 'Acciones'">
                {{ colLabel(column) }}
            </mat-header-cell>

            <ng-container *ngIf="column !== 'Acciones' && column !== 'Fecha alta' && column !== 'Fecha modificación'">
                <mat-cell *matCellDef="let object" class="mat-cell"
                    [attr.data-label]="column === 'Último paso trámite' ? ('TRAMITES.COL.ULTIMO_PASO_SHORT' | translate) : colLabel(column)"
                    [attr.data-role]="column === 'Estado' ? 'status' : column === 'Nombre del trámite' ? 'title' : null"
                    [class]="object[column]=='COMPLETADO'?'completado':(object[column]=='BAJA POR INACTIVIDAD' || object[column]=='BAJA POR CIERRE DE PROCEDIMIENTO' || object[column]=='BAJA POR USUARIO' || object[column]=='FIRMADO BAJA USUARIO'?'baja':'')"
                    [style]="valuesEnum(object[column])?'color: var(--blue);':''">
                    {{ object[column] }}
                </mat-cell>
            </ng-container>

            <ng-container *ngIf="column === 'Fecha alta' || column === 'Fecha modificación'">
                <mat-cell *matCellDef="let object" class="mat-cell"
                    [attr.data-label]="colLabel(column)"
                    data-role="meta"
                    [class]="object[column]=='COMPLETADO'?'completado':''"
                    [style]="valuesEnum(object[column])?'color: var(--blue);':''">
                    {{ formatDate(object[column]) }}
                </mat-cell>
            </ng-container>

            <ng-container *ngIf="column === 'Acciones'">
                <mat-cell *matCellDef="let object" class="mat-cell em-td-actions" data-role="actions">
                    <div class="em-actions-wrap">
                        <button [disabled]="actionProgres" type="button" class="em-icon-btn"
                            *ngIf="(object[column].pdfServidor && (object[column].estadoFirma=='FIRMADO_CON_REGISTRO' || object[column].estadoFirma=='FIRMADO_BAJA_USUARIO'))?true:false"
                            [matTooltip]="'TRAMITES.TOOLTIP_DOWNLOAD' | translate"
                            matTooltipClass="em-tooltip"
                            matTooltipPosition="left"
                            (click)="downloadJustificante(object[column].pdfServidor)">
                            <mat-icon *ngIf="!pdfsDownload.includes(object[column].pdfServidor)">download</mat-icon>
                            <div class="spinner-border spinner-border-sm" *ngIf="isInProgress && pdfsDownload.includes(object[column].pdfServidor)"></div>
                        </button>
                        <button [disabled]="actionProgres" type="button" class="em-icon-btn"
                            *ngIf="(!object[column].pdfServidor && object[column].pdfCliente && object[column].estadoFirma=='FIRMADO_CON_REGISTRO')?true:false"
                            [matTooltip]="'TRAMITES.TOOLTIP_DOWNLOAD' | translate"
                            matTooltipClass="em-tooltip"
                            matTooltipPosition="left"
                            (click)="downloadJustificante(object[column].pdfCliente)">
                            <mat-icon *ngIf="!pdfsDownload.includes(object[column].pdfCliente)">download</mat-icon>
                            <div class="spinner-border spinner-border-sm" *ngIf="isInProgress && pdfsDownload.includes(object[column].pdfCliente)"></div>
                        </button>
                        <button [disabled]="actionProgres" type="button" class="em-icon-btn"
                            *ngIf="(!object[column].pdfServidor && !object[column].pdfCliente && object[column].estadoFirma=='FIRMADO_CON_REGISTRO')?true:false"
                            [matTooltip]="'TRAMITES.TOOLTIP_GENERATE' | translate"
                            matTooltipClass="em-tooltip"
                            matTooltipPosition="left"
                            (click)="downloadJustificanteRegen(object[column].id)">
                            <mat-icon *ngIf="!pdfsDownloadRegen.includes(object[column].id)">refresh</mat-icon>
                            <div class="spinner-border spinner-border-sm" *ngIf="isInProgress && pdfsDownloadRegen.includes(object[column].id)"></div>
                        </button>
                        <button type="button" class="em-icon-btn"
                            *ngIf="puedeVerFirmantesAutorizados(object[column])"
                            [matTooltip]="'TRAMITES.TOOLTIP_SIGNERS' | translate"
                            matTooltipClass="em-tooltip"
                            matTooltipPosition="left"
                            (click)="abrirEstadoFirmaAutorizados(object[column], object['Nombre del trámite'])">
                            <mat-icon>groups</mat-icon>
                        </button>
                        <button [disabled]="actionProgres" type="button" class="em-icon-btn"
                            [matTooltip]="'TRAMITES.TOOLTIP_ATTACH' | translate"
                            matTooltipClass="em-tooltip"
                            matTooltipPosition="left"
                            (click)="downloadAdjuntos(object[column].id)">
                            <mat-icon *ngIf="!adjuntosDownload.includes(object[column].id)">folder_zip</mat-icon>
                            <div class="spinner-border spinner-border-sm" *ngIf="isInProgress && adjuntosDownload.includes(object[column].id)"></div>
                        </button>
                    </div>
                </mat-cell>
            </ng-container>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row"></mat-row>
    </mat-table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5" showFirstLastButtons style="padding: 15px;">
    </mat-paginator>

    <div class="load-more-row" *ngIf="paginator?.hasNextPage()">
        <button type="button" class="load-more-btn" (click)="cargarMas()">{{ 'COMMON.LOAD_MORE' | translate }}</button>
    </div>

    <form (submit)="exportarCsv()">
        <button *ngIf="dataSource && isAdmin" class="btn btn-primary m-left" type="submit" (click)="mostrarSpinnerMsg(translate.instant('COMMON.GENERATING_CSV'))">{{ 'COMMON.EXPORT_CSV' | translate }}</button>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true" [name]="'litado_tramites_spinner'">
    <p style="color: white">{{ mensajeSpinner }}</p>
</ngx-spinner>
